import { customAlphabet } from 'nanoid';

export const nid = customAlphabet('1234567890abcdef', 12);
